import React from "react";

const RestockAlerts = () => {
  return (
    <div>
      <h3 className="text-lg font-bold">Templates</h3>
      <p>Rock Alerts Content goes here.</p>
    </div>
  );
};

export default RestockAlerts;